import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import { AuthorityRouteProps } from "./routes"
import Env from "../util/env"

export const renderRoutes = (routes: AuthorityRouteProps[]) =>
  routes ? (
    <Switch>
      {routes.map((route, i) => (
        <Route
          key={i}
          exact={route.exact}
          path={route.path}
          render={props => <route.component {...props} />}
        />
      ))}
    </Switch>
  ) : null
